import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import type { RequiredAnalyticalFeaturesInterface } from '@zaoblako/shared/modules/catalog/dtos/required-analytical-features.dto';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SettingsService {
  public constructor(private readonly http: HttpClient) {}

  public getRequiredAnalyticalFeatures(): Observable<RequiredAnalyticalFeaturesInterface> {
    return this.http.get<RequiredAnalyticalFeaturesInterface>('/basis/catalog/required-analytical-features');
  }

  public updateRequiredAnalyticalFeatures(features: RequiredAnalyticalFeaturesInterface): Observable<void> {
    return this.http.put<void>('/basis/catalog/required-analytical-features', features);
  }
}
